import { signal, Signal } from '@angular/core';

/**
 * Rotating "thinking" lines for every KI wait state — claude-style, but with
 * Hausverwaltungs-Humor. One random start, then rotation every ~2.5s.
 */
export const AI_LOADING_LINES: string[] = [
    'Blättere im Protokoll der letzten Eigentümerversammlung …',
    'Frage den Hausmeister — der weiß sowas immer …',
    'Zähle Mülltonnen am Stellplatz …',
    'Prüfe, ob der Aufzug wieder "gleich repariert" ist …',
    'Suche den Schlüssel für den Schlüsseltresor …',
    'Lese TOP 7 nochmal ganz genau …',
    'Warte auf Rückmeldung vom Handwerker (Tag 9 von 7–10) …',
    'Rechne das Hausgeld lieber zweimal nach …',
    'Entziffere die Unterschrift auf dem Übergabeprotokoll …',
    'Lüfte kurz stoß, wegen Schimmelprävention …',
    'Formuliere "unverbindlich" besonders verbindlich …',
    'Sortiere Belege — Q2 kommt schneller als man denkt …',
    'Höre den Anrufbeantworter ab, könnte ein Notfall sein …',
    'Prüfe die Teilungserklärung, Absatz irgendwas …',
    'Frage Jasmin, Corinna und beide Denises …',
    'Messe den Heizungsdruck rein vorsorglich …',
    'Suche im Verwaltervertrag nach dem Kleingedruckten …',
    'Bestätige den Eingang und prüfe den Sachverhalt …',
    'Zähle Mehrheiten nach Miteigentumsanteilen …',
    'Gieße die Pflanzen im Treppenhaus, einen Moment …',
];

/**
 * Starts the rotation and returns the line signal plus a stop handle — call stop()
 * when the response lands, the interval must not outlive the wait state.
 */
export function startAiLoadingLines(): { line: Signal<string>; stop: () => void } {
    const index = signal(Math.floor(Math.random() * AI_LOADING_LINES.length));
    const line = signal(AI_LOADING_LINES[index()]);
    const interval = setInterval(() => {
        index.set((index() + 1) % AI_LOADING_LINES.length);
        line.set(AI_LOADING_LINES[index()]);
    }, 2500);

    return { line, stop: () => clearInterval(interval) };
}
